import { Box, Typography , IconButton, Drawer, Skeleton, Grid,} from "@mui/material"
import { ArrowLeft } from "../../../../../../core/global/Icons"

export const FileInfo =({v,open, onClose , isLoading})=>{
        if (!v) return null;
    
    return(
        <Drawer anchor="right" open={open} onClose={onClose} variant="persistent" PaperProps={{sx: {width:'100vw'}}} hideBackdrop sx={{zIndex: 1301}}  >
            <Box  height='100%' width="100%" bgcolor="#FFFFFF" display="flex" flexDirection="column" >
                <Box minHeight="44px"  p="12px 16px" display="flex" alignItems="center" justifyContent='space-between'>
                    <Box>
                        <IconButton sx={{p: '0px'}} onClick={onClose}>
                            <ArrowLeft stroke="#313131" width={16} height={16} />
                        </IconButton>
                    </Box>
                    
                </Box>
                    <Box>
                        <Typography fontSize="16px" fontWeight={600} lineHeight="26px" p="10px 0px 0px 10px">Category Details</Typography>
                        <Grid container>
                        <Box display="flex" flexDirection="row" px={2} py={1} width="100%">
                            <Grid item xs={6}><Typography sx={{ fontSize:'14px'}} color="#737373" fontWeight={600}>Category Number:</Typography> </Grid>
                            <Grid  item xs={6} >
                                { isLoading? 
                                    <Skeleton variant="rectangle" width="50%"/> :
                                    <Typography color="#333333"  sx={{ fontSize:'14px', justifyItems:'left'}} >{v.category_number}</Typography>
                                }
                            </Grid>
                        </Box> 
                        <Box display="flex" flexDirection="row" px={2} py={1} width="100%" >
                            <Grid item xs={6}><Typography sx={{ fontSize:'14px'}}  color="#737373" fontWeight={600}>Name of Category:</Typography></Grid>
                            <Grid item xs={6}>
                                { isLoading?
                                    <Skeleton variant="rectangle" width="50%"/>
                                    :
                                    <Typography color="#333333" sx={{ fontSize:'14px', justifyItems:'left'}} >{v.name}</Typography>
                                }
                            </Grid>
                        </Box>
                            
                        <Box display="flex" flexDirection="row" px={2} py={1} width="100%">
                            <Grid item xs={6}>
                            <Typography sx={{ fontSize:'14px'}} color="#737373" fontWeight={600}>Type of Concern:</Typography></Grid>
                            <Grid item xs={6}>
                                { isLoading?
                                    <Skeleton variant="rectangle" width="50%"/>
                                    :
                                    <Typography color="#333333"   sx={{ fontSize:'14px',  textAlignLast:'right', wordBreak:'break-word',justifyItems:'left'}} >{v.type === 1 ? 'Suggestion/Recommendation' : 'Concern'}</Typography>
                                }
                            </Grid>
                        </Box>  
                            
                        <Box display="flex" flexDirection="row" px={2} py={1} width="100%">
                            <Grid item xs={6}><Typography sx={{ fontSize:'14px'}} color="#737373" fontWeight={600}>Status:</Typography></Grid>
                            <Grid item xs={6}>
                                { isLoading?
                                    <Skeleton variant="rectangle" width="50%"/>
                                    :
                                    <Box fontSize="14px" display="flex" justifyContent="center" width="50px" bgcolor={v.active === 1 ? '#00be811f' : '#E4E5E6'} color={v.active === 1 ? '#00be81' : '#7B7F82'} borderRadius="16px" px={1} >
                                    <Box sx={{height:'auto', fontSize:'12px'}}>{v.active === 1 ? 'Active' : 'Inactive'}</Box>
                                </Box>
                                }
                            </Grid>
                            
                        </Box>
                        </Grid>
                    </Box>
            </Box>
        </Drawer>
    )
}